import { IProductOption } from '../../../interfaces/Product.interfaces';
import { customAxios } from '../../common/customAxios';

interface IGetProductOptionByIdParams {
  productId: string;
}

export const getProductOptionById = ({ productId }: IGetProductOptionByIdParams): Promise<IProductOption[]> => {
  return customAxios.get(`/product-options/${productId}`);
};
